<div class="c-portlet u-bg-main u-shadow-mini" (window:resize)="onResize($event)">
	<app-loader [showLoader]="showLoad"></app-loader>
	<div class="c-portlet__content pos-relative map-height">
		<div>
			<div class="map-wrapper">
				<div id="map" class="map-height" style="width: 100%" [ngClass]="{ 'map-with-no-data': noData }"></div>
				<div
					id="geoInfo"
					*ngIf="!noData"
					[ngClass]="
						polygonLayerDetails.zone && enableZip && polygonLayerDetails.zip && enableZone ? 'grid-3' : 'grid-2'
					"
				>
					<div class="polygon-layer-info zone-div" *ngIf="enableZone && polygonLayerDetails.zone">
						Zone:<span>&nbsp;{{ polygonLayerDetails.zone }}</span>
					</div>
					<div class="polygon-layer-info zip-div" *ngIf="enableZip && polygonLayerDetails.zip">
						Postal Code:<span>&nbsp;{{ polygonLayerDetails.zip }}</span>
					</div>
					<div class="polygon-layer-info population-div" *ngIf="polygonLayerDetails.population">
						Population:<span>&nbsp;{{ polygonLayerDetails.population }}</span>
					</div>
				</div>
			</div>

			<div class="map-details-container">
				<div class="details-map-container">
					<div id="minimap" style="height: 200px"></div>
				</div>
				<div class="map-details-wrapper">
					<strong>Geofence Location</strong>
					<div class="map-region-dmographic-title">{{ geofenceCenterDetails ? geofenceCenterDetails.name : '' }}</div>
					<table class="accordion-table" style="width: 100%">
						<tbody>
							<tr *ngFor="let detail of geofenceCenterDetailsForMap" class="add-color par-title-font">
								<td class="top-keywords-col1">{{ detail.attribute }}</td>
								<td>
									<strong>{{ detail.value }}</strong>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
			<div>
				<div class="zoom-options">
					<div class="zoom-icon" (click)="zoomIn()">
						<i class="fa fa-plus" aria-hidden="true"></i>
					</div>
					<div class="zoom-icon" style="border-top: 0px" (click)="zoomOut()">
						<i class="fa fa-minus" aria-hidden="true"></i>
					</div>
				</div>
				<div id="product-list" class="legend-area" *ngIf="showLegend">
					<ul class="legend">
						<li
							class="legend_item primary-color-border"
							[ngClass]="{ 'item-selected': legendItem.isSelected, 'hide-button': legendItem.isDisabled }"
							(click)="selectedProductDetails(legendItem)"
							*ngFor="let legendItem of mapObj?.legend"
						>
							<span
								><strong>{{ legendItem.productName }}</strong></span
							><i
								*ngIf="legendItem.isSelected"
								class="fa fa-caret-left"
								[ngStyle]="{ 'font-size': '18px', color: colorPalette.primaryColor }"
							></i
							><i *ngIf="!legendItem.isSelected" class="space"></i>
						</li>
					</ul>
				</div>

				<div class="legend-area geofence-legend">
					<strong style="padding: 9px; color: #000">Legend</strong>
					<ul class="legend" style="text-align: left">
						<li class="legend_item primary-color-border">
							<span
								><strong
									><i class="fa fa-circle" style="color: #1f77bc; border: 1px solid #fff"></i> &nbsp;Geofence</strong
								></span
							>
						</li>
						<li class="legend_item primary-color-border">
							<span
								><strong
									><i class="fa fa-circle" style="color: #cbe0ef; border: 1px solid #fff"></i> &nbsp;Geo Recency</strong
								></span
							>
						</li>
					</ul>
				</div>
			</div>
			<div></div>

			<div class="no-data-container" *ngIf="noData">
				<div class="map-no-data">No Data to Display</div>
			</div>
		</div>
	</div>
</div>
